/* GSM Reparatie Purmerend - premium productpagina (V1): knop, gekozen waarden, extra producten en tabs */
(function () {
  'use strict';
  function init(root) {
    if (root.hasAttribute('data-grp-pp-ready')) return;
    root.setAttribute('data-grp-pp-ready', '');
    var dataEl = root.querySelector('[data-grp-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-grp-id]');
    var buy = root.querySelector('[data-grp-pp-buy]');
    var label = root.querySelector('[data-grp-pp-label]');
    var form = root.querySelector('.grp-pp__form');

    function variant() {
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }
    function update() {
      var v = variant();
      if (buy && v) {
        buy.disabled = !v.available;
        if (label) label.textContent = v.available ? (data.buttonText || 'Toevoegen aan winkelwagen') : (data.soldOutText || 'Niet op voorraad');
      }
      root.querySelectorAll('[data-grp-pp-val]').forEach(function (el) {
        var i = el.getAttribute('data-grp-pp-val');
        var sel = root.querySelector('[data-grp-value][data-option-index="' + i + '"].is-selected');
        if (sel) el.textContent = sel.getAttribute('data-grp-value');
      });
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-grp-value]')) setTimeout(update, 0);
    });
    update();

    /* Extra producten samen in de winkelwagen */
    if (form) {
      form.addEventListener('submit', function (e) {
        var extras = [].slice.call(root.querySelectorAll('[data-grp-addon]:checked'));
        if (!extras.length) return;
        e.preventDefault();
        var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
        extras.forEach(function (x) { items.push({ id: parseInt(x.value, 10), quantity: 1 }); });
        if (buy) buy.disabled = true;
        fetch((data.cartAdd || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          window.location.href = data.cartUrl || '/cart';
        }).catch(function () {
          if (buy) buy.disabled = false;
          form.submit();
        });
      });
    }

    /* Tabs: actieve tab volgt het scrollen */
    var tabs = [].slice.call(root.querySelectorAll('[data-grp-pp-tab]'));
    var secs = tabs.map(function (t) { return root.querySelector(t.getAttribute('href')); });
    if (tabs.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var k = secs.indexOf(en.target);
          tabs.forEach(function (t, j) { t.classList.toggle('is-active', j === k); });
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      secs.forEach(function (s) { if (s) io.observe(s); });
    }
  }
  function initAll() { document.querySelectorAll('[data-grp-pp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* V4: paneelachtergrond uit foto */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
  function avg(d, w, h, xs, ys) {
    var r = 0, g = 0, b = 0, n = 0;
    for (var y = ys[0]; y < ys[1]; y++) for (var x = xs[0]; x < xs[1]; x++) { var i = (y * w + x) * 4; if (d[i + 3] < 10) continue; r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
    return n ? [Math.round(r / n), Math.round(g / n), Math.round(b / n)] : null;
  }
  function paint(panel) {
    var c = mq && mq.matches ? panel._grpM : panel._grpD;
    if (!c) return;
    var s = c.join(',');
    panel.style.setProperty('--pp-bg', 'rgb(' + s + ')');
    panel.style.setProperty('--pp-bg-a', 'rgba(' + s + ',.75)');
    panel.style.setProperty('--pp-bg-0', 'rgba(' + s + ',0)');
    var lum = (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255;
    panel.classList.add('is-auto');
    panel.classList.toggle('is-dark', lum < 0.5);
    panel.classList.toggle('is-light', lum >= 0.5);
  }
  function sample(panel) {
    if (panel.hasAttribute('data-grp-bg')) return;
    panel.setAttribute('data-grp-bg', '');
    if (panel.classList.contains('grp-pp__panel--vol')) return;
    var img = panel.querySelector('.grp-pp__panel-img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    var url;
    try { url = new URL(src, window.location.href); url.searchParams.set('width', '80'); } catch (e) { return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, w, h);
        var d = cx.getImageData(0, 0, w, h).data;
        var band = Math.max(2, Math.round(w * 0.04));
        var textLeft = panel.classList.contains('grp-pp__panel--left');
        panel._grpD = textLeft ? avg(d, w, h, [0, band], [0, h]) : avg(d, w, h, [w - band, w], [0, h]);
        var bh = Math.max(2, Math.round(h * 0.04));
        panel._grpM = avg(d, w, h, [0, w], [h - bh, h]) || panel._grpD;
        paint(panel);
      } catch (e) { /* geen toegang tot foto: standaardstijl blijft */ }
    };
    im.src = url.toString();
  }
  function run() { document.querySelectorAll('.grp-pp__panel').forEach(sample); }
  if (mq && mq.addEventListener) mq.addEventListener('change', function () { document.querySelectorAll('.grp-pp__panel.is-auto').forEach(paint); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* V5: grote foto volgt gekozen variant op desktop */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  function swap(root) {
    if (!mq || !mq.matches) return;
    var gtest = root.querySelector('.grp-pp__gallery');
    if (!gtest || getComputedStyle(gtest).display !== 'grid') return;
    var dataEl = root.querySelector('[data-grp-json]'); var idInput = root.querySelector('[data-grp-id]');
    var gallery = root.querySelector('.grp-pp__gallery');
    if (!dataEl || !idInput || !gallery) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var id = parseInt(idInput.value, 10), v = null;
    for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) v = data.variants[i];
    if (!v || !v.media) return;
    var shot = gallery.querySelector('[data-media-id="' + v.media + '"]');
    var first = gallery.firstElementChild;
    if (!shot || shot === first) return;
    var badges = first.querySelector('.grp-pp__badges');
    first.classList.remove('grp-pp__shot--wide');
    shot.classList.add('grp-pp__shot--wide');
    if (badges) shot.insertBefore(badges, shot.firstChild);
    gallery.insertBefore(shot, first);
    var im = shot.querySelector('img');
    if (im) { im.loading = 'eager'; im.setAttribute('sizes', '(min-width: 990px) 55vw, 100vw'); }
  }
  function bind(root) {
    if (root.hasAttribute('data-grp-swap')) return;
    root.setAttribute('data-grp-swap', '');
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-grp-value]')) setTimeout(function () { swap(root); }, 30); });
    swap(root);
  }
  function run() { document.querySelectorAll('[data-grp-pp]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
